import type { BlogFeedItem } from "@/features/home/api/blogFeed";
import { WEBSITE_URL } from "@/features/config";

export const PINNED_BLOG_POST: BlogFeedItem = {
  title: "The research behind Paperclip",
  url: `${WEBSITE_URL}/blog/paperclip`,
  pubDate: new Date("2026-04-07"),
};
